import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareModule } from 'src/app/share-module';
import { AssetCardComponent } from './asset-card/asset-card.component';
import { CastComponent } from './cast/cast.component';
import { CategoriesMenuComponent } from './categories-menu/categories-menu.component';
import { ChangeLanguageComponent } from './change-language/change-language.component';
import { ChangePasswordComponentComponent } from './change-password-component/change-password-component.component';
import { ConsentComponent } from './consent/consent.component';
import { CowatchComponent } from './cowatch/cowatch.component';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PlayerComponent } from './player/player.component';
import { ProductsListComponent } from './products-list/products-list.component';
import { PromotionComponent } from './promotion/promotion.component';
import { RibbonComponent } from './ribbon/ribbon.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { WaterfallComponent } from './waterfall/waterfall.component';
import { WaterfallSelectionComponent } from './waterfall-selection/waterfall-selection.component';
import { UpdateSubscriberInfoComponent } from './update-subscriber-info/update-subscriber-info.component';
import { RibbonChannelComponent } from './ribbon-channel/ribbon-channel.component';

@NgModule({
    imports: [
        CommonModule,
        ShareModule
    ],
    declarations: [
        AssetCardComponent,
        CastComponent,
        CategoriesMenuComponent,
        ChangeLanguageComponent,
        ChangePasswordComponentComponent,
        ConsentComponent,
        CowatchComponent,
        FooterComponent,
        NavbarComponent,
        PlayerComponent,
        ProductsListComponent,
        PromotionComponent,
        RibbonComponent,
        SearchInputComponent,
        WaterfallComponent,
        WaterfallSelectionComponent,
        UpdateSubscriberInfoComponent,
        RibbonChannelComponent
    ],
    exports: [
        AssetCardComponent,
        CastComponent,
        CategoriesMenuComponent,
        ChangeLanguageComponent,
        ChangePasswordComponentComponent,
        ConsentComponent,
        CowatchComponent,
        FooterComponent,
        NavbarComponent,
        PlayerComponent,
        ProductsListComponent,
        PromotionComponent,
        RibbonComponent,
        SearchInputComponent,
        WaterfallComponent,
        WaterfallSelectionComponent,
        UpdateSubscriberInfoComponent,
        RibbonChannelComponent
    ]
})

export class ComponentsModule { }